<!--end::Header Logo-->
<div class="d-flex align-items-stretch me-3 menu-header">
    <!--begin::Header Logo-->
    <div class="header-logo">
        <a href="javascript:void(0)" style="margin-left: 25px">
            <!-- <img alt="Logo" src="../../../../../assets/media/logos/informate-logo-black-desktop.png" class="logo-default max-h-40px" /> -->
            <img alt="Logo" src="../../../../../../assets/media/logos/{{ IA }}" class="logo-sticky" style="height: 60px" />
        </a>
    </div>
    <!--end::Header Logo-->

    <ng-container *ngIf="headerMenuSelfDisplay" class="mobile_menu">
        <!--begin::Header Menu Mobile Toggle-->
        <button class="btn p-0 burger-icon burger-icon-left ms-4" id="kt_header_mobile_toggle">
            <span></span>
        </button>
        <!--end::Header Menu Mobile Toggle-->
    </ng-container>

    <ng-container>
        <!--begin::Header Menu Wrapper-->
        <div class="header-menu-wrapper header-menu-wrapper-left" id="kt_header_menu_wrapper">
            <!--begin::Header Menu-->
            <!-- Don't change id => 'kt_header_menu' -->
            <ng-container>
                <ul class="menu-nav" [ngClass]="ulCSSClasses">
                    <li class="menu-item menu-item-rel" help_links="menu-item-active">
                        <a class="menu-link" [routerLink]="['/home']" [routerLinkActive]="['active']">
                            <span class="menu-text" translate="MENU.DASHBOARD"><i class="fas fa-home"></i> {{ 'INFORMATE_HEADER.Home' | transloco }}</span>
                            <ng-container *ngIf="rootArrowEnabled">
                                <i class="menu-arrow"></i>
                            </ng-container>
                        </a>
                    </li>
                </ul>
                <!-- end::Header Nav -->
            </ng-container>

            <!--end::Header Menu-->
        </div>
        <!--end::Header Menu Wrapper-->
    </ng-container>
</div>
